@for (option of options; track option) {
  <div class="radio-group">
    <p-radioButton [name]="name" [value]="option" [(ngModel)]="ngModel" [disabled]="isDisabled" size="small"
      [required]="isRequired" (onClick)="handleClick(option)">
    </p-radioButton>
    <label>{{ option }}</label>
  </div>
}